import React from 'react'
import { Link } from 'react-router-dom'
import {database} from '../firebase';
import {doc, deleteDoc,updateDoc,collection,query,where,getDocs} from 'firebase/firestore';

function UserPost(props){

    return(
<DataPost data={props.data} isLogin={props.isLogin} id={props.id}/>
    )
}

export default UserPost;


class DataPost extends React.Component{
  constructor(){
    super()
    this.state = {
      month:['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
      id_post:'',
      total_post:null
    }
  }

async componentDidMount(){
      //   GET ALL POST
      const db = collection(database,"user")
      const q = query(db ,where("uid","==" ,this.props.id))
      await getDocs(q).then(res => {
        res.docs.map(item => {
        const data = item.data()
        console.log(data);
    return this.setState({total_post :this.state.total_post = data.total_post})
          });
        })
      }
    deletePost = (e) => {
          const id = e.target.dataset.id
          const user =  doc(database,'user',this.props.id )
          const docDelete = doc(database,'post',id )
          const docUpdate = doc(database,'user',this.props.id) 

            if(confirm("Are you sure want to delete this post")){
updateDoc(user,{total_post:this.state.total_post - 1})
deleteDoc( docDelete)
.then(() =>{
  alert("delete sukses")
})
.catch(err => {
  console.log(err.message);
})
            }else{
        
            }
          }


  render(){
    const  timestamp = this.props.data == null ? "" : this.props.data.timestamp.seconds
    const time = new Date(timestamp*1000)
    const date = `${time.getDate()} ${this.state.month[time.getMonth()]} ${time.getFullYear()}`
    const post_contents = Array.isArray(this.props.data.post_content) ? this.props.data.post_content.match(/.{1,250}/g).map(text => {
        return <p className='post-text'>{text}</p>
        }) : ""
                      
  const hide = {
    height:`${500}px`,
    overflow:'hidden'
}

    return(
      this.props.data === undefined ? "" : <div class="post-card">
<div className='post' >
<div className='user-post-info'>
    <div className='post-user'>
    <h2 className='post-title'><Link to={`/post-detail/${this.props.data.post_id}`}>{this.props.data.title}</Link></h2>
        <span className='date'>Post at : {date}</span>
    </div>
<div className={this.props.isLogin ? 'actions' : 'hide'}>
<i class="fa fa-trash delete" data-id={this.props.data.post_id} onClick={this.deletePost}></i>
</div>
</div>
<div className={this.props.data.post_image === null ? 'hide' : 'image-wrap'}>
<Link to={`/post-detail/${this.props.data.post_id}`}>
<img src={this.props.data.post_image} />
</Link>
</div>
<div className='post-artikel'>
{post_contents }
</div>
</div>
</div>
    )
  }
}